import React from 'react';
import cx from 'classnames';
import SwitchButton from 'src/components/switchButton';
import { Row, Col } from 'react-bootstrap';
import styles from '../../accountManagementView.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';

class ShareSettings extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedShareSettings = this.localizedSettings.account.account_management.tabs.share_settings;
  }

  onChange(field, value){
    this.props.onChange(field, value);
  }

  render() {
    const settings = this.props.value.shareSettings || {};
    const download = _.get(settings, 'download', true);
    const reshare = _.get(settings, 'reshare', true);
    const gated = _.get(settings, 'gated', false);
    const downloadEditable = _.get(settings, 'downloadEditable', false);
    const validateEmailDomain = _.get(settings, 'validateEmailDomain', false);
    const validateEmailOtp = _.get(settings, 'validateEmailOtp', false);


    return (
      <div className={styles.shareSettings}>
        <Row>
          <Col md={6}>
            <div className={styles.option}>
              <div className={styles.details}>
                <h5>{this.localizedShareSettings.download.title}</h5>
                <p>{this.localizedShareSettings.download.description}</p>
              </div>
              <div className={styles.action}>
                <SwitchButton id="shareDownload" handleCheck={this.onChange.bind(this, 'download', !download)} checked={download} />
              </div>
            </div>
            {download &&
              <div className={cx(styles.permission, styles.downloadOptions)}>
                <div className={styles.options}>
                  <div className={styles.option} onClick={this.onChange.bind(this, 'downloadEditable', !downloadEditable)}>
                    <i className={cx(downloadEditable ? 'fa-solid fa-check-circle' : 'paperflite-radio-button-unselected')} aria-hidden="true"></i>
                    <label>{this.localizedShareSettings.download.options.editable}</label>
                  </div>
                  <div className={styles.option} onClick={this.onChange.bind(this, 'downloadEditable', !downloadEditable)}>
                    <i className={cx(!downloadEditable ? ' fa-solid fa-check-circle' : 'paperflite-radio-button-unselected')} aria-hidden="true"></i>
                    <label>{this.localizedShareSettings.download.options.read_only}</label>
                  </div>
                </div>
                <div className={styles.help}>{this.localizedShareSettings.download.note}</div>
              </div>
            }
          </Col>
        </Row>
        <Row>  
          <Col md={6}>
            <div className={styles.option}>
              <div className={styles.details}>
                <h5>{this.localizedShareSettings.reshare.title}</h5>
                <p>{this.localizedShareSettings.reshare.description}</p>
              </div>
              <div className={styles.action}>
                <SwitchButton id="shareReshare" handleCheck={this.onChange.bind(this, 'reshare', !reshare)} checked={reshare} />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className={styles.option}>
              <div className={styles.details}>
                <h5>{this.localizedShareSettings.gating.title}</h5>
                <p>{this.localizedShareSettings.gating.description}</p>
              </div>
              <div className={styles.action}>
                <SwitchButton id="shareGated" handleCheck={this.onChange.bind(this, 'gated', !gated)} checked={gated} />
              </div>
            </div>
            {gated &&
              <div className={cx(styles.permission, styles.gatingOptions)} >
                <label>{this.localizedShareSettings.gating.validate_work_email}</label>
                <i className={cx(validateEmailDomain ? ' fa-solid fa-check-circle' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this.onChange.bind(this, 'validateEmailDomain', !validateEmailDomain)}></i>
              </div>
            }
            {gated &&
              <div className={cx(styles.permission, styles.gatingOptions)} >
                <label>Validate with OTP</label>
                <i className={cx(validateEmailOtp ? ' fa-solid fa-check-circle' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this.onChange.bind(this, 'validateEmailOtp', !validateEmailOtp)}></i>
              </div>
            }
          </Col>
        </Row>
      </div>
    )
  }
}

export default ShareSettings;